import AppURL from "../constants/AppURL";
import { ToastSuccess, ToastWarning } from "../constants/Toast";
import { fetchDataFromApi, postJsonDataToTheServer, putDataToTheServer } from "./api";
import { BillingEntryProps, ContraVoucherInfoProps, IssueProductListReducer, PurchaseProductList, SalesProductListReducer, VoucherEntry } from "./models/Models";
import { PURCHASE_CLEAR_PRODUCT_ITEM, ISSUE_CLEAR_PRODUCT_ITEM, SALES_CLEAR_PRODUCT_ITEM, BILLING_REPORT_LIST_VIEW } from "../store/inventorySlice";
import { Dispatch } from "@reduxjs/toolkit";
import { useState } from "react";
import { CONTRA_VOUCHER_ENTRY_CLEAR_INFO_ITEM, CONTRA_VOUCHER_ENTRY_CLEAR_LIST_ITEM, MAHASUL_ENTRY_LIST_VIEW, RESET_BILLING_PARTICULAR_LIST } from "../store/accountSlice";
import { extractUserID } from "./extractData";
import { CONSUMER_PROFILE_DETAILS_VIEW } from "../store/orgSlice";
import { BSToADUSFormat } from "../constants/DateFormat";

export const purchaseDataPost = async (purchaseProductList: PurchaseProductList[], dispatch: Dispatch) => {
    const modifiedData: PurchaseProductList[] = purchaseProductList.map((item, index) => ({
        ...item,
        sale_issue: 0
    }));

    try {
        if (purchaseProductList.length > 0) {
            await postJsonDataToTheServer(AppURL.InventoryURL + 'inventory/product/transaction/create/view/', modifiedData).then((res) => {
                if (res?.status === 201) {
                    ToastSuccess({ message: res?.message });
                    dispatch(PURCHASE_CLEAR_PRODUCT_ITEM());
                } else if (res?.status === 400) {
                    ToastWarning({ message: res?.message });
                }
                else {
                    ToastWarning({ message: "Some Issue" });
                }
            });
        } else {
            ToastWarning({ message: "First, items are added to the table." })
        }

    } catch (error) {
        console.log(error);
    }

};



export const issueDataPost = async (issueProductList: IssueProductListReducer[], dispatch: Dispatch) => {
    const modifiedData: IssueProductListReducer[] = issueProductList.map((item) => ({
        ...item,
        sale_issue: 1
    }));

    try {
        if (issueProductList.length > 0) {
            await postJsonDataToTheServer(AppURL.InventoryURL + 'inventory/product/transaction/create/view/', modifiedData).then((res) => {
                if (res?.status === 201) {
                    ToastSuccess({ message: res?.message });
                    dispatch(ISSUE_CLEAR_PRODUCT_ITEM());
                } else if (res?.status === 400) {
                    ToastWarning({ message: res?.message });
                } else {
                    ToastWarning({ message: "Some Issue" });
                }
            });
        } else {
            ToastWarning({ message: "First, add items to the table." });
        }

    } catch (error) {
        console.log(error);
    }
};
export const salesDataPost = async (salesProductList: SalesProductListReducer[], dispatch: Dispatch) => {
    const modifiedData: SalesProductListReducer[] = salesProductList.map((item) => ({
        ...item,
        sale_issue: 2
    }));

    try {
        if (salesProductList.length > 0) {
            await postJsonDataToTheServer(AppURL.InventoryURL + 'inventory/product/transaction/create/view/', modifiedData).then((res) => {
                if (res?.status === 201) {
                    ToastSuccess({ message: res?.message });
                    dispatch(SALES_CLEAR_PRODUCT_ITEM());
                } else if (res?.status === 400) {
                    ToastWarning({ message: res?.message });
                } else {
                    ToastWarning({ message: "Some Issue" });
                }
            });
        } else {
            ToastWarning({ message: "First, add items to the table." });
        }

    } catch (error) {
        console.log(error);
    }
};




export const handleKeyPress = async (event: any, isFetching: any, setIsFetching: any, REQUEST_TIMEOUT: any, values: any, setOnEmployeeData: any, onClose: any) => {
    if (event.key === "Enter" && !isFetching) {
        setIsFetching(true);
        setTimeout(() => {
            setIsFetching(false);
        }, REQUEST_TIMEOUT);
        try {
            await fetchDataFromApi(AppURL.InventoryURL + "inventory/product/member/search/report/list/?member_sn=" + values.member_sn).then((res) => {
                setOnEmployeeData(res);
                console.log(res)
                onClose(true);
            });
        } catch (error: any) {
            alert(error.response.detail)
        }
    }
};


export const resetSeialKey = async () => {
    try {

        await fetchDataFromApi(AppURL.ApplicationURL + 'app/sequence/number/auto/create/view/').then((res) => {
            if (res?.status === 200) {
                ToastSuccess({ message: res?.message });

            } else if (res?.status === 400) {
                ToastWarning({ message: res?.message });
            }
            else {
                ToastWarning({ message: "Some Issue" });
            }
        });
    } catch (error) {
        console.log(error);
    }

};


export const useOnce = (callback: () => void) => {
    const [called, setCalled] = useState(false);

    const callOnce = () => {
        if (!called) {
            callback();
            setCalled(true);
        }
    };

    return callOnce;
};


export const contraVoucherDataPost = async (contraVoucherEntryList: VoucherEntry[], contraVoucherInfo: ContraVoucherInfoProps, dispatch: Dispatch) => {
    const formData = new FormData();
    formData.append("contra_voucher_list", JSON.stringify(contraVoucherEntryList));
    formData.append("contra_voucher_info", JSON.stringify(contraVoucherInfo));

    try {
        if (contraVoucherEntryList.length > 0) {
            await postJsonDataToTheServer(AppURL.AccountURL + 'account/contra/voucher/entry/create/view/', formData).then((res) => {
                if (res?.status === 201) {
                    ToastSuccess({ message: res?.message });
                    dispatch(CONTRA_VOUCHER_ENTRY_CLEAR_LIST_ITEM());
                    dispatch(CONTRA_VOUCHER_ENTRY_CLEAR_INFO_ITEM());

                } else if (res?.status === 400) {
                    ToastWarning({ message: res?.message });
                } else {
                    ToastWarning({ message: "Some Issue" });
                }
            });
        } else {
            ToastWarning({ message: "First, add items to the table." });
        }

    } catch (error) {
        console.log(error);
    }
};

export const mahasulEntryListDateWise = async (dispatch: Dispatch, urls: string) => {
    try {

        await fetchDataFromApi(urls).then((res) => {
            dispatch(MAHASUL_ENTRY_LIST_VIEW(res));
        });

    } catch (error) {
        console.log(error);
    }
};
export const ProfileLockUnlockMethod = async (id: number, password: string, refetch: () => void) => {
    const userId = extractUserID();

    const formData = new FormData();
    formData.append("password", password);
    formData.append("member_sn", id?.toString());
    formData.append("user_id", userId?.toString() || "1"); // Convert userId to string

    try {
        await putDataToTheServer(AppURL.FrontOfficeURL + "front/consumer/profile/lock/unlock/update/view/" + id, formData).then((res) => {
            if (res.status === 200) {
                refetch();
                ToastSuccess({ message: res.message });
            } else {
                ToastWarning({ message: res.message });
            }
        });
    } catch (error) {
        console.log(error);
    }
};


export const ProfileDetailsShowView = async (id: number, password: string, navigate: Function, dispatch: Dispatch) => {
    const userId = extractUserID();
    try {
        await fetchDataFromApi(`${AppURL.FrontOfficeURL}front/consumer/profile/lock/unlock/details/view/${id}?password=${password}&&user_id=${userId}`).then((res) => {
            if (res.status === 200) {
                dispatch(CONSUMER_PROFILE_DETAILS_VIEW(res?.data));
                navigate("/front/office/profile/details/view/" + id)
            } else {
                ToastWarning({ message: res?.response?.data?.message });
            }
        });
    } catch (error) {
        console.log(error);
    }
};

export const postMahasulDataOnServer = async (date_n: string, reader_id: number) => {
    const userId = extractUserID();
    const formData = new FormData();
    formData.append("date_n", date_n);
    formData.append("reader", reader_id?.toString());
    formData.append("date_e", BSToADUSFormat(date_n));
    formData.append("user_id", userId?.toString() ?? "1");

    try {
        await postJsonDataToTheServer(`${AppURL.AccountURL}account/reader/data/post/account/create/view/`, formData).then((res) => {
            if (res.status === 201) {
                ToastSuccess({ message: res?.message });
            } else {
                ToastWarning({ message: res?.response?.data?.message });
            }
        });
    } catch (error) {
        console.log(error);
    }
};

export const mahasulBillingEntrySave = async (values: BillingEntryProps, dispatch: Dispatch, billingParticularList: any) => {
    const userId = extractUserID();
    const formData = new FormData();
    formData.append("date_ne", "2082/04/10");
    formData.append("date_en", "2082/04/10");
    formData.append("total_pay_amt", values.total_every_month_amt?.toString());
    formData.append("chhut_amt", values.chhut_amt?.toString());
    formData.append("fine_amt", values.fine_amt?.toString());
    formData.append("member_sn", values.member_sn?.toString());
    formData.append("deposit_month", values.deposit_month?.toString());
    formData.append("deposit_year", values.deposit_year?.toString());
    formData.append("payment_mode", values.payment_mode?.toString());
    formData.append("advance_amt", values.check_ad_advace ? values.advance_amt?.toString() : "0");
    formData.append("refund_advance_amt", values.adjust_advance ? values.refund_advance_amt?.toString() : "0");
    formData.append("bank_sglsn", values.bank_sglsn?.toString());
    formData.append("user_id", userId?.toString() ?? "1");
    formData.append("receive_amt", values.receive_amt?.toString());
    formData.append("tot_particular_amt", values.tot_particular_amt?.toString());
    formData.append("particular_lists", JSON.stringify(billingParticularList));
    try {
        await postJsonDataToTheServer(`${AppURL.AccountURL}account/mahasul/billing/entry/create/view/`, formData).then((res) => {
            if (res.status === 201) {
                ToastSuccess({ message: res?.message });
                localStorage.setItem('bill_no', res?.bill_no || "");
                dispatch(BILLING_REPORT_LIST_VIEW(res));
            } else {
                ToastWarning({ message: res?.response?.data?.message });
            }
        });
    } catch (error) {
        console.log(error);
    }
};

export const putUserSadhiyarNoUpdateView = async (member_sn: number, sadhiyar_no: number | null, next_member_sn: number | null, marga_tole: string) => {
    const userId = extractUserID();
    const formData = new FormData();
    formData.append("member_sn", member_sn?.toString());
    formData.append("sadhiyar_no", sadhiyar_no?.toString() ?? "");
    formData.append("next_member_sn", next_member_sn?.toString() ?? "");
    formData.append("marga_tole", marga_tole ?? "");

    try {
        await putDataToTheServer(`${AppURL.FrontOfficeURL}front/customer/sadhiyar/no/update/view/` + member_sn, formData).then((res) => {
            if (res.status === 200) {
                ToastSuccess({ message: res?.message });
            } else {
                ToastWarning({ message: res?.response?.data?.message });
            }
        });
    } catch (error) {
        console.log(error);
    }
};